import { useCallback, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '@doda/pc/src/redux/hooks';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';

import { tabSelector } from '@doda/pc/src/redux/selectors/queryParams';
import { measureScroll50 } from '../../logics/analytics';
import { Tab } from '../../types/tab';

/**
 * 計測発火する画面スクロール量の閾値
 */
export type ScrollThreshold = 50;

/**
 * 画面スクロール量に応じた計測発火
 * @param initialTab 初期選択タブ
 */
export const useScrollAnalytics = (initialTab: Tab) => {
  const dispatch = useAppDispatch();
  const isAdobeScript = useAppSelector(adobeAnalyticsScriptsSelector);
  const scrolled = useRef<Record<ScrollThreshold, boolean>>({
    50: false,
  });
  const tab = useAppSelector(tabSelector) ?? initialTab;

  const handleScroll = useCallback(() => {
    if (tab === 'pr') return;
    const scrollPosition = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.body.clientHeight;
    const scrollPercentage =
      (scrollPosition / (documentHeight - windowHeight)) * 100;

    Object.entries(scrolled.current).forEach(([key, hasScrolled]) => {
      const percentage = parseInt(key, 10) as ScrollThreshold;
      if (scrollPercentage >= percentage && !hasScrolled) {
        scrolled.current[percentage] = true;
        measureScroll50(isAdobeScript, dispatch);
      }
    });
  }, [isAdobeScript, scrolled, dispatch, tab]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};
